import React from "react";
import { usePermissao } from "../contexts/PermissaoContext";
import { Alert, Box, Button, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

interface RotaProtegidaPorPermissaoProps {
  children: React.ReactNode;
  modulo: string | string[];
  fallbackPath?: string;
}

const RotaProtegidaPorPermissao: React.FC<RotaProtegidaPorPermissaoProps> = ({
  children,
  modulo,

  fallbackPath = "/home",
}) => {
  const { podeVerModulo, loading } = usePermissao();

  // Se ainda está carregando as permissões, mostrar loading
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h6">Carregando permissões...</Typography>
      </Box>
    );
  }

  const temAcesso = Array.isArray(modulo)
    ? modulo.some((m) => podeVerModulo(m))
    : podeVerModulo(modulo);

  // Se o usuário não tem permissão para ver este módulo
  if (!temAcesso) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: 3,
          p: 3,
        }}
      >
        <Alert
          severity="error"
          sx={{
            fontSize: "1.1rem",
            "& .MuiAlert-message": {
              fontSize: "1.1rem",
            },
          }}
        >
          <Typography variant="h5" gutterBottom>
            Acesso Negado
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Você não tem permissão para acessar esta página.
          </Typography>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => (window.location.href = fallbackPath)}
            sx={{ mt: 1 }}
          >
            Voltar para Home
          </Button>
        </Alert>
      </Box>
    );
  }

  // Se tem permissão, renderiza o conteúdo
  return <>{children}</>;
};

export default RotaProtegidaPorPermissao;
